import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const UserManagement: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        User Management
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="body1">
            User management functionality coming soon...
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserManagement;
